import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = ({ theme }) => `
  background: ${theme.colors.base.chrome200};
  bottom: ${px2rem(-4)};
  height: ${px2rem(4)};
  left: ${px2rem(8)};
  position: absolute;
  right:${px2rem(8)};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome200: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'ProgressBarWrapper',
  styled.div,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./components/ProgressBar/ProgressBarWrapper.js